import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@frontend/components/atoms/Tooltip";
import { useLingui } from "@lingui/react/macro";

/** Adds a row to a list, held in its fieldset's legend. */
export function AddButton({ onClick }: { onClick: () => void }) {
  const { t } = useLingui();

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant="ghost"
            size="sm"
            aria-label={t`Add`}
            onClick={onClick}
          >
            <Icon name="Plus" size="sm" />
          </Button>
        }
      />

      <TooltipContent>{t`Add`}</TooltipContent>
    </Tooltip>
  );
}
